import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import pictoCart from '~/assets/img/header/picto-cart@2x.png';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/account.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/account-on.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/account-connected.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/infobulle.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/geoloc.svg';
import IconTextLink from '~/components/molecules/Header/IconTextLink.vue';
import AccountLayer from '~/components/specific/MainHeader/AccountLayer.vue';
import FaqLayer from '~/components/specific/MainHeader/FaqLayer.vue';

var SearchItem = function SearchItem() {
  return import(
  /* webpackChunkName: "search" */
  '~/components/specific/TheHeader/Menu/SecondaryNav/Items/SearchItem.vue');
};

export default {
  name: 'Banner',
  components: {
    SearchItem: SearchItem,
    IconTextLink: IconTextLink,
    AccountLayer: AccountLayer,
    FaqLayer: FaqLayer
  },
  props: {
    cartUrl: {
      type: String,
      default: ''
    },
    homeUrl: {
      type: String,
      default: ''
    },
    helpUrl: {
      type: String,
      default: ''
    },
    accountUrl: {
      type: String,
      default: ''
    },
    storeLocUrl: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      pictoCart: pictoCart,
      accountHover: false,
      faqOpen: false
    };
  },
  computed: _objectSpread({}, mapGetters({
    cart: 'cart/total',
    user: 'user/me',
    locale: 'i18n/locale'
  }), {
    accountDescription: function accountDescription() {
      return this.user ? this.$t('account-greeting', {
        name: this.user.firstName
      }) : this.$t('account-description');
    },
    accountIcon: function accountIcon() {
      if (this.accountHover) return 'account-on';
      return this.user ? 'account-connected' : 'account';
    }
  }),
  methods: {
    tracking: function tracking(evt, data) {
      this.$root.$emit('generic-tracking', evt, {
        data: _objectSpread({
          event_category: 'Header',
          event_action: '',
          event_label: ''
        }, data)
      });
    },
    open: function open(item) {
      item.setAttribute('aria-expanded', true);
    },
    close: function close(item) {
      item.setAttribute('aria-expanded', false);
    },
    faqClick: function faqClick(event) {
      this.tracking(event, {
        event_action: 'Aide et contact'
      });
      this.faqOpen = false;
    }
  }
};